// extracted by mini-css-extract-plugin
export default {"body":"chatBody_body__0ZuFF","aiMessage":"chatBody_aiMessage__CC9sp"};